import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/chart/chart-bar-blue.png'
import _imports_1 from '../assets/chart/chart-line-green.png'
import _imports_2 from '../assets/long-insure/dispatch.png'
import _imports_3 from '../assets/long-insure/worker.png'
import _imports_4 from '../assets/long-insure/insure-company.png'
import _imports_5 from '../assets/closetwo.png'
import _imports_6 from '../assets/block.png'
import _imports_7 from '../assets/festival/pc-fee-up.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "block-header" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-ai-c"
}
const _hoisted_5 = { class: "block-content" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "balance" }
const _hoisted_9 = { class: "number" }
const _hoisted_10 = { class: "block" }
const _hoisted_11 = { class: "block-header" }
const _hoisted_12 = { class: "block-content" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "number" }
const _hoisted_16 = { class: "block" }
const _hoisted_17 = { class: "block-content row nav" }
const _hoisted_18 = { class: "block plan" }
const _hoisted_19 = { class: "block-content plan-list" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "plan-item-head" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "item-head-type" }
const _hoisted_24 = { class: "head-type-top" }
const _hoisted_25 = { class: "head-type-time" }
const _hoisted_26 = { class: "plan-item-labels" }
const _hoisted_27 = { class: "item-label item-label-type" }
const _hoisted_28 = { class: "item-label item-label-type" }
const _hoisted_29 = { class: "item-label item-label-type" }
const _hoisted_30 = { class: "plan-item-labels" }
const _hoisted_31 = { class: "plan-item-count" }
const _hoisted_32 = { class: "item-count-total" }
const _hoisted_33 = {
  key: 0,
  class: "plan-item-tip"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "item-tip-time" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "item-tip-time" }
const _hoisted_38 = {
  key: 1,
  class: "plan-item-tip"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "item-tip-time" }
const _hoisted_42 = {
  key: 2,
  class: "plan-item-tip"
}
const _hoisted_43 = { class: "block-content plan-list" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "plan-item-head" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "item-head-type" }
const _hoisted_48 = { class: "head-type-top" }
const _hoisted_49 = { class: "head-type-time" }
const _hoisted_50 = { class: "plan-item-labels" }
const _hoisted_51 = { class: "item-label item-label-type" }
const _hoisted_52 = { class: "item-label item-label-type" }
const _hoisted_53 = { class: "item-label item-label-type" }
const _hoisted_54 = { class: "plan-item-labels" }
const _hoisted_55 = { class: "plan-item-count" }
const _hoisted_56 = { class: "item-count-total" }
const _hoisted_57 = {
  key: 0,
  class: "plan-item-tip"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "item-tip-time" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "item-tip-time" }
const _hoisted_62 = {
  key: 1,
  class: "plan-item-tip"
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "item-tip-time" }
const _hoisted_65 = {
  key: 2,
  class: "plan-item-tip"
}
const _hoisted_66 = { class: "block" }
const _hoisted_67 = { class: "block-header" }
const _hoisted_68 = { class: "block-content" }
const _hoisted_69 = { class: "flex-x-jus-btn mg-b-10" }
const _hoisted_70 = { class: "mytab" }
const _hoisted_71 = {
  key: 2,
  class: "infomsg"
}
const _hoisted_72 = { class: "flex-x-jus-btn" }
const _hoisted_73 = { class: "fc6B6B86 fs-12 mg-b-12" }
const _hoisted_74 = { class: "fs-14" }
const _hoisted_75 = {
  key: 3,
  class: "infomsg"
}
const _hoisted_76 = { class: "flex-x-jus-btn" }
const _hoisted_77 = { class: "fc6B6B86 fs-12 mg-b-12" }
const _hoisted_78 = { class: "fs-14" }
const _hoisted_79 = { class: "tcbox" }
const _hoisted_80 = { class: "tccontent" }
const _hoisted_81 = { class: "top" }
const _hoisted_82 = { class: "ctbox" }
const _hoisted_83 = { class: "tcbtnbox" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { class: "flex justify-center mg-t-40" }
const _hoisted_87 = { class: "img-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_popupRecharge = _resolveComponent("popupRecharge")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "block-title" }, "账户余额", -1)),
        _createElementVNode("div", {
          class: "block-more point",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
                    _ctx.$router.push({
                        path: '/longinsure/bill'
                    })
                    ))
        }, [
          (_ctx.user.isPcAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[19] || (_cache[19] = [
                _createElementVNode("div", { class: "" }, "查看详情", -1),
                _createElementVNode("div", { class: "triangle" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "key" }, "余额（元）", -1)),
            _createElementVNode("div", _hoisted_8, [
              _cache[21] || (_cache[21] = _createTextVNode(" ￥")),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.accountBalance), 1)
            ])
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("img", {
            class: "img-chart",
            src: _imports_0
          }, null, -1))
        ]),
        _createElementVNode("button", {
          class: "mini-btn recharge-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.longcz && _ctx.longcz(...args)))
        }, "充值")
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "block-title" }, "当前在保人数", -1)),
        _createElementVNode("div", {
          class: "block-more point",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.$router.push({
                        path: '/long-insure/ensure'
                    })
                    ))
        }, _cache[24] || (_cache[24] = [
          _createElementVNode("div", { class: "" }, "查看详情", -1),
          _createElementVNode("div", { class: "triangle" }, null, -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "key" }, "人数", -1)),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.allEnsureCount), 1)
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("img", {
            class: "img-chart",
            src: _imports_1
          }, null, -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "block-header" }, [
        _createElementVNode("div", { class: "block-title" }, "便捷导航"),
        _createElementVNode("div", { class: "block-more" })
      ], -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: "nav-item point",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (
                    _ctx.$router.push({
                        path: '/long-insure-dispatch'
                    })
                    ))
        }, _cache[28] || (_cache[28] = [
          _createElementVNode("img", { src: _imports_2 }, null, -1),
          _createElementVNode("div", null, "被派遣单位", -1)
        ])),
        _createElementVNode("div", {
          class: "nav-item point",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (
                    _ctx.$router.push({
                        path: '/long-insure-worker'
                    })
                    ))
        }, _cache[29] || (_cache[29] = [
          _createElementVNode("img", { src: _imports_3 }, null, -1),
          _createElementVNode("div", null, "人员查询", -1)
        ])),
        _createElementVNode("div", {
          class: "nav-item point",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (
                    _ctx.$router.push({
                        path: '/long-insure-report'
                    })
                    ))
        }, _cache[30] || (_cache[30] = [
          _createElementVNode("img", { src: _imports_2 }, null, -1),
          _createElementVNode("div", null, "报案理赔", -1)
        ])),
        _createElementVNode("div", {
          class: "nav-item point",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onLinkToInsureCompany && _ctx.onLinkToInsureCompany(...args)))
        }, _cache[31] || (_cache[31] = [
          _createElementVNode("img", { src: _imports_4 }, null, -1),
          _createElementVNode("div", null, "保司列表", -1)
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_el_card, { style: {"width":"100%"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeName,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeName) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "有效方案",
                name: "OK"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.okPlanList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(['plan-item point']),
                        onClick: ($event: any) => (_ctx.toInsureDetail(item.companyPlanId))
                      }, [
                        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "plan-status-icon status-icon-ok" }, [
                          _createElementVNode("span", { class: "plan-status-text" }, "启用")
                        ], -1)),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("img", {
                            class: "item-head-img",
                            src: item.logo,
                            alt: ""
                          }, null, 8, _hoisted_22),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(item.planName), 1),
                            _createElementVNode("div", _hoisted_25, _toDisplayString(item.planEndTime ? item.planEndTime : '长期有效'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(item.insurePlanType == 0?'灵活保单':item.insurePlanType == 1?'月单':'日保单'), 1),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(item.effectType == 1 ? '次日生效' : item.effectType == 2 ? '整点生效' : '立即生效'), 1),
                          _createElementVNode("div", _hoisted_29, _toDisplayString(item.insurePlanType == 0?'按日计费':item.insurePlanType == 1?'按月购买':'按次购买'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dangerLevel, (k, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass({ 'item-label': true, 'item-label-level': k ===3 })
                            }, _toDisplayString(k ===3 ? '1-3': k) + "类 ", 3))
                          }), 256))
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(item.ensureCount), 1),
                          _cache[33] || (_cache[33] = _createTextVNode(" 在保人数 "))
                        ]),
                        (item.insurePlanType == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              ( item.effectType == 1 )
                                ? (_openBlock(), _createElementBlock("text", _hoisted_34, [
                                    _cache[34] || (_cache[34] = _createTextVNode("*请在")),
                                    _createElementVNode("text", _hoisted_35, _toDisplayString(item.allowOperateTime), 1),
                                    _cache[35] || (_cache[35] = _createTextVNode("之前，完成次日加保或今日减保"))
                                  ]))
                                : _createCommentVNode("", true),
                              ( item.effectType == 2 )
                                ? (_openBlock(), _createElementBlock("text", _hoisted_36, [
                                    _cache[36] || (_cache[36] = _createTextVNode("*请在")),
                                    _createElementVNode("text", _hoisted_37, _toDisplayString(item.allowOperateTime), 1),
                                    _cache[37] || (_cache[37] = _createTextVNode("之前，完成次日加保或今日减保，第一次激活方案，只能选择次日生效"))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (item.insurePlanType == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              (item.code === 'period_047_RB')
                                ? (_openBlock(), _createElementBlock("text", _hoisted_39, [
                                    _cache[38] || (_cache[38] = _createTextVNode("*请在")),
                                    _cache[39] || (_cache[39] = _createElementVNode("text", { class: "item-tip-time" }, "15:20 ", -1)),
                                    _createTextVNode("之前，完成次日加保或者今日减保，请在当月月底前三个工作日" + _toDisplayString(item.allowOperateDate) + "完成续保", 1)
                                  ]))
                                : (item.effectType == 1 || item.code !== 'period_047_RB')
                                  ? (_openBlock(), _createElementBlock("text", _hoisted_40, [
                                      _cache[40] || (_cache[40] = _createTextVNode("*请在")),
                                      _createElementVNode("text", _hoisted_41, _toDisplayString(item.allowOperateTime), 1),
                                      _cache[41] || (_cache[41] = _createTextVNode("之前，完成次日加保或今日减保"))
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (item.insurePlanType == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[42] || (_cache[42] = [
                              _createElementVNode("text", null, [
                                _createTextVNode("*加保成功后，立即生效，默认保障"),
                                _createElementVNode("text", { class: "item-tip-time" }, _toDisplayString('24小时'))
                              ], -1)
                            ])))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_20))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "失效方案",
                name: "NO"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noPlanList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(['plan-item point']),
                        onClick: ($event: any) => (_ctx.toInsureDetail(item.companyPlanId))
                      }, [
                        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "plan-status-icon status-icon-no" }, [
                          _createElementVNode("span", { class: "plan-status-text" }, "禁用")
                        ], -1)),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("img", {
                            class: _normalizeClass(['item-head-img disabled']),
                            src: item.logo,
                            alt: ""
                          }, null, 8, _hoisted_46),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, _toDisplayString(item.planName), 1),
                            _createElementVNode("div", _hoisted_49, _toDisplayString(item.planEndTime ? item.planEndTime : '长期有效'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, _toDisplayString(item.insurePlanType == 0?'灵活保单':item.insurePlanType == 1?'月单':'日保单'), 1),
                          _createElementVNode("div", _hoisted_52, _toDisplayString(item.effectType == 1 ? '次日生效' : item.effectType == 2 ? '整点生效' : '立即生效'), 1),
                          _createElementVNode("div", _hoisted_53, _toDisplayString(item.effectType == 0?'按日计费':item.effectType == 1?'按月购买':'按次购买'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dangerLevel, (k, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass({ 'item-label': true, 'item-label-level': k ===3 })
                            }, _toDisplayString(k ===3 ? '1-3': k) + "类 ", 3))
                          }), 256))
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("span", _hoisted_56, _toDisplayString(item.ensureCount), 1),
                          _cache[44] || (_cache[44] = _createTextVNode(" 在保人数 "))
                        ]),
                        (item.insurePlanType == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              ( item.effectType == 1 )
                                ? (_openBlock(), _createElementBlock("text", _hoisted_58, [
                                    _cache[45] || (_cache[45] = _createTextVNode("*请在")),
                                    _createElementVNode("text", _hoisted_59, _toDisplayString(item.allowOperateTime), 1),
                                    _cache[46] || (_cache[46] = _createTextVNode("之前，完成今日减保，"))
                                  ]))
                                : _createCommentVNode("", true),
                              ( item.effectType == 2 )
                                ? (_openBlock(), _createElementBlock("text", _hoisted_60, [
                                    _cache[47] || (_cache[47] = _createTextVNode("*请在")),
                                    _createElementVNode("text", _hoisted_61, _toDisplayString(item.allowOperateTime), 1),
                                    _cache[48] || (_cache[48] = _createTextVNode("之前，完成今日减保，第一次激活方案，只能选择次日生效，"))
                                  ]))
                                : _createCommentVNode("", true),
                              _cache[49] || (_cache[49] = _createElementVNode("text", { class: "item-tip-no" }, "当前方案只能减保，不支持加保", -1))
                            ]))
                          : _createCommentVNode("", true),
                        (item.insurePlanType == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              ( item.effectType == 1 )
                                ? (_openBlock(), _createElementBlock("text", _hoisted_63, [
                                    _cache[50] || (_cache[50] = _createTextVNode("*请在")),
                                    _createElementVNode("text", _hoisted_64, _toDisplayString(item.allowOperateTime), 1),
                                    _cache[51] || (_cache[51] = _createTextVNode("之前，完成今日减保，"))
                                  ]))
                                : _createCommentVNode("", true),
                              _cache[52] || (_cache[52] = _createElementVNode("text", { class: "item-tip-no" }, "当前方案只能减保，不支持加保", -1))
                            ]))
                          : _createCommentVNode("", true),
                        (item.insurePlanType == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, _cache[53] || (_cache[53] = [
                              _createElementVNode("text", null, [
                                _createTextVNode("*加保成功后，立即生效，默认保障"),
                                _createElementVNode("text", { class: "item-tip-time" }, _toDisplayString('24小时'))
                              ], -1)
                            ])))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_44))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _cache[57] || (_cache[57] = _createElementVNode("div", { class: "block-title" }, "人员统计", -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.peopleStatisticsType,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.peopleStatisticsType) = $event)),
            onChange: _ctx.onPeopleStatisticsType,
            class: "people-statistics-type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: 0,
                label: "全部"
              }, {
                default: _withCtx(() => _cache[55] || (_cache[55] = [
                  _createTextVNode("全部")
                ])),
                _: 1
              }),
              _createVNode(_component_el_option, {
                value: 1,
                label: "在保"
              }, {
                default: _withCtx(() => _cache[56] || (_cache[56] = [
                  _createTextVNode("在保")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        (
                    _ctx.peopleStatistics?.occupationGroup?.length === 0 &&
                    _ctx.statisticsTab === 0
                )
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "暂无数据"
            }))
          : _createCommentVNode("", true),
        (
                    _ctx.peopleStatistics?.serveCompanyGroup?.length === 0 &&
                    _ctx.statisticsTab === 1
                )
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: "暂无数据"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'tabitem': true, 'activetab': _ctx.statisticsTab === 0 }),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onPeopleStatisticsTab(0)))
            }, " 工种(" + _toDisplayString(_ctx.total1) + ") ", 3),
            _createElementVNode("div", {
              class: _normalizeClass({ 'tabitem': true, 'activetab': _ctx.statisticsTab === 1 }),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onPeopleStatisticsTab(1)))
            }, " 被派遣单位(" + _toDisplayString(_ctx.total2) + ") ", 3)
          ]),
          _cache[58] || (_cache[58] = _createElementVNode("div", { class: "discrabe" }, [
            _createElementVNode("div", { class: "line" }),
            _createTextVNode(" 在保人数 ")
          ], -1))
        ]),
        (_ctx.statisticsTab === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listone, (item, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, _toDisplayString(item.occupationName), 1),
                    _createElementVNode("div", _hoisted_74, _toDisplayString(item.count), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_progress, {
                      "text-inside": true,
                      "show-text": false,
                      percentage: (item.count / _ctx.maxone) * 100
                    }, null, 8, ["percentage"])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.statisticsTab === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listtwo, (item, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, _toDisplayString(item.serveCompanyName), 1),
                    _createElementVNode("div", _hoisted_78, _toDisplayString(item.count), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_progress, {
                      "text-inside": true,
                      "show-text": false,
                      percentage: (item.count / _ctx.maxtwo) * 100
                    }, null, 8, ["percentage"])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isDeletePopup,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isDeletePopup) = $event)),
      width: "1400px",
      left: "50%",
      top: "5%"
    }, {
      default: _withCtx(() => _cache[59] || (_cache[59] = [
        _createElementVNode("div", { class: "record" }, "开通保险方案", -1)
      ])),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.isRecharge)
      ? (_openBlock(), _createBlock(_component_popupRecharge, {
          key: 0,
          ref: "rechargeRef",
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isRecharge = false)),
          useWay: "InsureRechargePeriodZgrs",
          openBank: _ctx.openBank,
          bankNo: _ctx.bankNo,
          bankName: _ctx.bankName,
          onDetermine: _ctx.onDetermine,
          dataTitle: "安心保充值"
        }, null, 8, ["openBank", "bankNo", "bankName", "onDetermine"]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "tc",
          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.showtcflag = false), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _cache[61] || (_cache[61] = _createElementVNode("div", null, null, -1)),
                _createElementVNode("div", {
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closetc && _ctx.closetc(...args)))
                }, _cache[60] || (_cache[60] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    alt: ""
                  }, null, -1)
                ]))
              ]),
              _cache[63] || (_cache[63] = _createElementVNode("div", { class: "bac2" }, null, -1)),
              _createElementVNode("div", _hoisted_82, [
                _cache[62] || (_cache[62] = _createStaticVNode("<div class=\"tctext\" data-v-07f46ee6><div class=\"ctop\" data-v-07f46ee6><img src=\"" + _imports_6 + "\" alt=\"\" data-v-07f46ee6><span class=\"text\" data-v-07f46ee6>余额不足自动断保规则更新预告</span></div><p class=\"p\" data-v-07f46ee6> 当系统内<span class=\"boxshadle\" data-v-07f46ee6>余额不足</span>次日扣款(例如账户余额50元，次日需消耗100元)，将会在当日的 <span class=\"boxshadle\" data-v-07f46ee6>23:00分系统自动断保，人工无法干预。</span></p><p class=\"p\" data-v-07f46ee6> 在收到首次短信通知或者群里客服人员通知之后，请务必及时充值， <span class=\"boxshadle\" data-v-07f46ee6>断保以后发生工伤</span><span class=\"boxshadle\" data-v-07f46ee6>将无法理赔。</span></p></div><div class=\"tctext\" data-v-07f46ee6><div class=\"ctop\" data-v-07f46ee6><img src=\"" + _imports_6 + "\" alt=\"\" data-v-07f46ee6><span class=\"text\" data-v-07f46ee6>特别约定</span></div><p class=\"p\" data-v-07f46ee6> 自2023年9月1日起，本保单所承接年龄超45周岁的保安或保洁人员因工作原因发生的猝死责任限额为主险责任限额的1/3。 </p></div>", 2)),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closetc && _ctx.closetc(...args)))
                  }, "我知道了")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      width: "600px",
      modelValue: _ctx.showInsureRate,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showInsureRate) = $event)),
      title: "通知",
      onClose: _ctx.onInsureRateClose
    }, {
      default: _withCtx(() => [
        (_ctx.increaseData?.changeState === 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_84, " 非常抱歉，您当前理赔率已达到【" + _toDisplayString(_ctx.increaseData.currentRate) + "%】，系统将于【" + _toDisplayString(_ctx.increaseData.effectDate) + "】的零点，针对您所开通的所有方案，涨价【" + _toDisplayString(_ctx.increaseData.increaseRate) + "%】，请您知悉。 ", 1))
          : _createCommentVNode("", true),
        (_ctx.increaseData?.changeState === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_85, " 恭喜您，当前理赔率是【" + _toDisplayString(_ctx.increaseData.currentRate) + "%】，已低于【" + _toDisplayString(_ctx.increaseData.deductRate) + "%】。涨赔已生效，系统将于次日零点，恢复所有方案价格。涨赔未生效，系统所有方案价格一切正常。 ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_86, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onInsureRateClose
          }, {
            default: _withCtx(() => _cache[64] || (_cache[64] = [
              _createTextVNode("我已知晓")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showRiseUp,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showRiseUp) = $event)),
      width: "790px",
      onClose: _ctx.onRateRiseClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_87, [
          _cache[65] || (_cache[65] = _createElementVNode("img", {
            src: _imports_7,
            class: "img",
            alt: ""
          }, null, -1)),
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onRateRiseClose && _ctx.onRateRiseClose(...args)))
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ]))
}